import { SimpleSearchFilter } from 'module/api/filter/types';
import { User } from 'module/api/user/types';
import { GroupedFilter } from 'module/types/filter-field/grouped-filter/filter';
import {
  CustomGroupSectionNode,
  CustomSectionNode,
} from 'api/custom-section/types';

export enum SourceType {
  Meeting = 'MEETING',
  Company = 'COMPANY',
  Email = 'EMAIL',
  CustomerUser = 'CUSTOMER_USER',
}
export enum PageType {
  Meeting = 'MEETING',
  Company = 'COMPANY_V2',
  // CompanyV2 = 'COMPANY_V2',
  People = 'PEOPLE',
  Email = 'EMAIL',
  Manual = 'MANUAL',
}
export interface OperationPayload {
  operation: 'PUT' | 'POST' | 'DELETE';
  payload: CustomSectionNode | CustomGroupSectionNode;
}
export type JSONContent = {
  type?: string;
  attrs?: Record<string, any>;
  content?: JSONContent[];
  marks?: {
    type: string;
    attrs?: Record<string, any>;
    [key: string]: any;
  }[];
  text?: string;
  [key: string]: any;
};

export type TiptapJson = {
  type: 'doc';
  content: JSONContent[];
};

export interface TemplateFilters {
  pageTriggerCondition?: SimpleSearchFilter;
}

export interface PageTemplateLite<
  PageTypeT extends PageType = PageType,
  SourceTypeT extends SourceType = SourceType,
> {
  templateId: number;
  sourceType: SourceTypeT;
  pageType: PageTypeT;
  templateName: string;
  filters: TemplateFilters;
  templateSource: TemplateSource;
  lastUpdatedBy: User;
  createdBy: User;
  createdAt: string;
  updatedAt: string;
  accountId: number;
  deleted: boolean;
  enabled: boolean;
  isDefault?: boolean;
}
export type PageTemplate<
  PageTypeT extends PageType = PageType,
  SourceTypeT extends SourceType = SourceType,
> = PageTemplateLite<PageTypeT, SourceTypeT> & {
  htmlPayload: string;
  templateSectionIds: string[];
  tiptapJson: TiptapJson;
};
export type PageTemplateSourceLite = { templateId: number };
type TemplateSource = {
  pageTemplateSources: PageTemplateSourceLite[];
};
interface BasePageTemplatePayload<
  PageTypeT extends PageType = PageType,
  SourceTypeT extends SourceType = SourceType,
> {
  templateName: string;
  operations: OperationPayload[];
  tiptapJson: TiptapJson;
  htmlPayload: string;
  sourceType: SourceTypeT;
  pageType: PageTypeT;
  templateSectionIds?: string[];
  filters: TemplateFilters;
  templateSource?: Partial<TemplateSource>;
}

export type UpdatePageTemplatePayload<
  PageTypeT extends PageType = PageType,
  SourceTypeT extends SourceType = SourceType,
> = Partial<BasePageTemplatePayload<PageTypeT, SourceTypeT>> & {
  templateId: number;
};
export type CreatePageTemplatePayload<
  PageTypeT extends PageType = PageType,
  SourceTypeT extends SourceType = SourceType,
> = Partial<
  Omit<BasePageTemplatePayload<PageTypeT, SourceTypeT>, 'templateId'>
>;

export interface BasePageTemplateUiState<
  PageTypeT extends PageType = PageType,
  SourceTypeT extends SourceType = SourceType,
> {
  templateId: number;
  templateName: string;
  changedSections?: CustomSectionNode[];
  existingSectionsIds?: string[];
  tiptapJson: any;
  htmlPayload: any;
  sourceType: SourceTypeT;
  pageType: PageTypeT;
  templateSectionIds?: string[];
  operations?: OperationPayload[];
  filters: {
    pageTriggerCondition?: GroupedFilter;
  };
}
